var _path, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChieldAltLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4668 21.0666L19.0002 24.4166C17.2224 25.75 14.7779 25.75 13.0002 24.4166L8.5335 21.0666C6.51905 19.5558 5.3335 17.1847 5.3335 14.6666V7.33331C5.3335 6.22874 6.22893 5.33331 7.3335 5.33331H24.6668C25.7714 5.33331 26.6668 6.22874 26.6668 7.33331V14.6666C26.6668 17.1847 25.4813 19.5558 23.4668 21.0666Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9998,
    cy: 13.3333,
    r: 1.33333,
    fill: "#1E1E1E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9998,
    cy: 13.3333,
    r: 1.33333,
    fill: "#1E1E1E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9998,
    cy: 13.3333,
    r: 1.33333,
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChieldAltLight);
export default __webpack_public_path__ + "static/media/Chield_alt_light.f7fad5bb4d75dfa4191267283d093ce7.svg";
export { ForwardRef as ReactComponent };